var map = {
	"./54_hamster.mp3": "1bae0",
	"./55_parrot.mp3": "59fb",
	"./56_canary.mp3": "76a8",
	"./M_Brilliant.mp3": "ec3b",
	"./M_Excellent.mp3": "1d62",
	"./M_Fantastic.mp3": "8a89",
	"./M_Great.mp3": "0a84",
	"./M_Perfect.mp3": "5709",
	"./M_Think again.mp3": "029d",
	"./M_Try again.mp3": "a63f",
	"./M_Very good.mp3": "a0a5",
	"./M_Well done.mp3": "3b8e5",
	"./M_Work harder.mp3": "e3f3",
	"./click.mp3": "1784",
	"./false.mp3": "ad16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f40b";